import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export interface ITreatmentPlanData {
  treatmentType?: string;
  treatmentRegimen?: string;
}

@Component({
  selector: 'ncis-treatment-plan-dialog',
  templateUrl: './treatment-plan-dialog.component.html',
  styleUrls: ['./treatment-plan-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TreatmentPlanDialogComponent {
  @Output()
  public readonly continueEvent = new EventEmitter<void>();

  @Input()
  public treatmentPlanData!: ITreatmentPlanData;
}
